"use strict";
/**
 * 화면 표기용 코드 → 라벨 상수.
 *
 * ⚠ 이 파일은 이 패키지에서 **유일하게 런타임 값**을 내보낸다. `index.ts` 규칙대로 프론트는
 * 원칙적으로 타입만 가져오지만, 라벨 사전처럼 서버·프론트가 **같은 문자열**을 써야 하는 값은
 * 한 곳에 두는 편이 안전하다. 프론트에서 값 import가 문제되면(Vite CJS named export)
 * `Record<AccessLevel, string>`으로 재정의해 컴파일 타임 동기화만 가져가도 된다.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACCESS_LEVEL_LABEL = void 0;
exports.ACCESS_LEVEL_LABEL = {
    ADMIN: '관리',
    EDIT: '등록/수정',
    VIEW: '조회',
};
